import {Translatable, TranslationKey} from 'common/i18n';

export type ValidityStatus = `invalid` | `valid`;

export enum QuestionType {
  Work = `work`,
  Role = `role`,
  Name = `name`,
}

export enum TextFieldKey {
  FirstName = `firstname`,
  LastName = `lastname`,
}

export type OtherInputQuestionType = SuffixOther<QuestionType>;

export type SurveyDataType = {
  [key in QuestionType]: QuestionDataType;
};

export type QuestionOption = {
  label: Translatable;
  value: string;
};

export type QuestionDataType = OptionQuestionDataType | TextQuestionDataType;

type QuestionDataTypeCommon = {
  type: QuestionType;
  title: Translatable;
  subTitle: Translatable;
  imgPath: string;
};

export type OptionQuestionDataType = {
  options: QuestionOption[];
  otherInputDetails?: {placeholder: Translatable};
  stackBubbles: boolean; // for long text bubbles
  isMultiSelect: boolean;
  randomize: boolean;
} & QuestionDataTypeCommon;

type TextInput = {
  key: TextFieldKey; // the key used to store the value in the response
  label: TranslationKey;
  placeholder: TranslationKey;
};

export type TextQuestionDataType = {
  textInputs: TextInput[];
} & QuestionDataTypeCommon;

type SuffixOther<T extends string> = `${T}_other`;

type DefaultUserResponseType = Partial<Record<QuestionType, Set<string>>>;
type UserOtherInputResponse = Partial<Record<OtherInputQuestionType, string>>;
type UserTextInputResponse = Partial<Record<TextFieldKey, string>>;

export type UserResponseType = DefaultUserResponseType & UserOtherInputResponse & UserTextInputResponse;

export type OtherInputValidityStatus = {
  [key in OtherInputQuestionType]?: ValidityStatus;
};

export type TextInputValidityStatus = Partial<Record<TextFieldKey, ValidityStatus>>;

export type StepPointerType = {
  [key in QuestionType]?: {
    data: QuestionDataType;
    next: QuestionType | undefined;
    previous: QuestionType | undefined;
  };
};
